export enum AccountAssistanceRdvStatus {
    DONE = 'DONE',
    ONGOING = 'ONGOING',
    FORTHCOMING = 'FORTHCOMING',
    CANCELLED = 'CANCELLED',
}
